'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionLabelOutline = function ActionLabelOutline(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z' })
  );
};
ActionLabelOutline = (0, _pure2.default)(ActionLabelOutline);
ActionLabelOutline.displayName = 'ActionLabelOutline';
ActionLabelOutline.muiName = 'SvgIcon';

exports.default = ActionLabelOutline;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/label-outline.js
// module id = 2548
// module chunks = 0